/** Feature keys accepted by the trial upgrade-request endpoint (shared with BE). */
export const TRIAL_FEATURES = {
  ACTIVATION: 'ACTIVATION',
  ADVANCED_OPTIONS: 'ADVANCED_OPTIONS',
  AI_SUMMARY: 'AI_SUMMARY',
  CONSUMPTION: 'CONSUMPTION',
  CONVERSATION: 'CONVERSATION',
  CUSTOM: 'CUSTOM',
  DATA_SOURCE: 'DATA_SOURCE',
  DISCOVER: 'DISCOVER',
  DRAG_AND_DROP_COMPARE: 'DRAG_AND_DROP_COMPARE',
  DRAG_AND_DROP_SEGMENTATION: 'DRAG_AND_DROP_SEGMENTATION',
  EXPORT: 'EXPORT',
  GWI: 'GWI',
  MRI_SIMMONS: 'MRI_SIMMONS',
  OPINIONS: 'OPINIONS',
  SEGMENTATION: 'SEGMENTATION',
  SHARE: 'SHARE',
  STANLEY_QUERY: 'STANLEY_QUERY',
  TGI: 'TGI',
  WW_GWI_MED: 'WW_GWI_MED',
  TOTAL_SOCIAL_VIEW: 'TOTAL_SOCIAL_VIEW',
  TRIAL_QUOTA_EXHAUSTED: 'TRIAL_QUOTA_EXHAUSTED',
  QUERY_BUILDER_COMPARE: 'QUERY_BUILDER_COMPARE',
  QUERY_BUILDER_COPY_AUDIENCE: 'QUERY_BUILDER_COPY_AUDIENCE',
} as const;

export type TrialFeature = (typeof TRIAL_FEATURES)[keyof typeof TRIAL_FEATURES];

export const TRIAL_UPGRADE_REQUEST_ENDPOINTS = {
  UPGRADE_REQUEST: '/companies/trial/upgrade-request',
} as const;

const ACCOUNTS_BASE_URL: Record<string, string> = {
  develop: 'https://api-develop-accounts.helixa.ai',
  staging: 'https://api-staging-accounts.helixa.ai',
  production: 'https://api-accounts.helixa.ai',
};

export const getAccountsApiBaseUrl = (
  apiEnv = process.env.REACT_APP_API_ENV
): string =>
  ACCOUNTS_BASE_URL[apiEnv || 'develop'] || ACCOUNTS_BASE_URL.develop;
